import ChartFormatService from '../utils/services/format';
import { StudyPlotType } from '../sources/charting_library';
import {
  CustomIndicator,
  IContext,
  PineJS,
  RawStudyMetaInfoId,
  StudyInputValue,
  StudyMetaInfo,
} from '../sources/charting_library.min';

type CustomIndicatorInputCallback = <T extends StudyInputValue>(
  index: number,
) => T;

export const customIndicators: (
  pineJS: PineJS,
) => Promise<readonly CustomIndicator[]> = async (pineJS: PineJS) =>
  Promise.resolve([
    {
      name: 'oi',
      metainfo: {
        _metainfoVersion: 40,
        id: 'oi@tv-basicstudies-1' as RawStudyMetaInfoId,
        scriptIdPart: '',
        name: 'oi',
        description: 'Open Interest',
        shortDescription: 'Open Interest',
        is_hidden_study: false,
        is_price_study: false,
        isCustomIndicator: true,
        format: { precision: 2, type: 'price' },
        plots: [
          {
            id: 'plot_0',
            type: StudyPlotType.Line,
          },
        ],
        defaults: {
          styles: {
            plot_0: {
              linestyle: 0,
              visible: true,
              linewidth: 2,
              plottype: 2,
              trackPrice: false,
              transparency: 40,
            },
          },
          precision: 2,
          inputs: {},
        },
        styles: {
          plot_0: {
            title: 'Open Interest',
            histogramBase: 0,
          },
        },
        inputs: [],
      } as StudyMetaInfo,
      constructor: function constructor() {
        this.init = function init(
          context: IContext,
          inputCallback: CustomIndicatorInputCallback,
        ) {
          this._context = context;
          this._input = inputCallback;
          const interval = ChartFormatService.mapTVChartInterval(`${pineJS.Std.period(this._context)}`);
          const customSymbolName = `${pineJS.Std.ticker(this._context)}#customOI_${interval}`;
          (this._context as IContext).new_sym(
            customSymbolName,
            pineJS.Std.period(this._context),
          );
        };
        this.main = function main(
          context: IContext,
          inputCallback: CustomIndicatorInputCallback,
        ) {
          this._context = context;
          this._input = inputCallback;
          (this._context as IContext).select_sym(1);
          const studyResult = pineJS.Std.close(this._context);
          return Number.isNaN(studyResult) ? [0] : [studyResult];
        };
      },
    },
  ]);
